import { useField } from "@formiz/core";
import { Spacer } from "@nextui-org/react";
import { PropTypes } from "prop-types";
import React, { useState } from "react";

import { Row, Text } from "@/components/customComponents";

const FormField = (props) => {
  // eslint-disable-next-line @typescript-eslint/naming-convention -- Component is intentionally uppercase because it is rendered as a React component
  const { component: Component, title, desc, view, spacer = 1, persona, disabled, rightTitleButton, showError: showErrorProp } = props;
  const { value, setValue, errorMessage, isValid, isPristine, isSubmitted, otherProps } = useField(props);
  const [isFocused, setIsFocused] = useState(false);

  // Check if the field has a value to show validation errors for imported data
  const hasValue = () => {
    if (Array.isArray(value)) {
      return value.length > 0;
    }
    return value;
  };

  const showError = !isValid && !isFocused && (showErrorProp !== undefined ? showErrorProp : !isPristine || isSubmitted || hasValue());
  const { rightText, toLowerCase = false, ...filteredProps } = otherProps;

  return (
    <>
      <Row className={`mb-1 ml-1 ${rightTitleButton ? "justify-between items-end" : ""}`}>
        <p className={" " + (persona ? "flex flex-col gap-2" : undefined)}>
          <Text b variant={persona ? "lg" : "md"}>
            {title}
          </Text>
          {desc ? (
            <Text variant={persona ? "regular" : "xs"} type={persona ? "opacity-60" : "tracking-[-0.05px] leading-6 ml-3"}>
              {desc}
            </Text>
          ) : null}
        </p>
        {rightTitleButton ? <div className="mt-1">{rightTitleButton}</div> : null}
      </Row>
      {persona ? <Spacer y={2} /> : null}
      <Row className="flex-wrap">
        <Component
          {...filteredProps}
          value={value}
          onFocus={() => setIsFocused(true)}
          onBlur={() => setIsFocused(false)}
          onChange={(e) => {
            toLowerCase ? setValue(e?.target?.value?.toLowerCase()) : setValue(e?.target?.value);
          }}
          onClear={disabled ? null : () => setValue("")}
          helperColor={"error"}
          isDisabled={view ? true : false}
        />
        <Row className="justify-between items-center grow">
          {showError ? (
            <Text type={"error"} variant={"md"}>
              {errorMessage}
            </Text>
          ) : null}
          {rightText ? (
            <Row justify="end">
              <Text variant={"sm"}>{rightText}</Text>
            </Row>
          ) : null}
        </Row>
      </Row>
      <Spacer y={spacer} />
    </>
  );
};

FormField.propTypes = {
  component: PropTypes.elementType.isRequired,
  textRight: PropTypes.string,
  title: PropTypes.string,
  desc: PropTypes.string,
  rightText: PropTypes.string,
  view: PropTypes.bool,
  name: PropTypes.string,
  spacer: PropTypes.number,
  toLowerCase: PropTypes.bool,
};
export default FormField;
